var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMainPlaySettingDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    fill: "#ffffff",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111.3,
    y: 90.1,
    width: 88.7,
    height: 19.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.9,
    y: 164.6,
    width: 120.1,
    height: 19.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 15.5,
    width: 198.8,
    height: 19.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7,125.4V58h49.7v19.9H59.6v75.5c0,16.4-13.4,29.8-29.8,29.8S0,170,0,153.4c0-16.4,13.4-29.8,29.8-29.8 C33.2,123.6,36.6,124.3,39.7,125.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(255, 0, 0)",
      strokeWidth: 15
    },
    d: "M 9.813 189.26 L 192.012 8.105"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMainPlaySettingDisabled);
export default __webpack_public_path__ + "static/media/ico-main-play-settingDisabled.f112fbb7eb4075b4533cb56b4c7bd05f.svg";
export { ForwardRef as ReactComponent };